
import { defineComponent, PropType } from "vue";
import BaseButton from "@/components/buttons/BaseButton/BaseButton.vue";

export default defineComponent({
  name: "EditSaveButton",
  components: { BaseButton },
  props: {
    editing: { type: Boolean, required: true },

    enabled: { type: Boolean, default: true },
    onClickEdit: { type: Function as PropType<() => void>, required: true },
    onClickSave: { type: Function as PropType<() => void>, required: true },
  },
});
